/** @import modules */

import { useTranslation }       from "react-i18next";

import { useParams }            from "react-router-dom";

import parse                    from 'html-react-parser';

import cookies                  from "js-cookie";

/** @import models */

import TechInfoModel            from "../../Models/TechnicalModel";

/** @import components */

import Breadcrumbs              from "../../Components/Layout/Header/Breadcrumbs";

import Layout                   from "../../Components/Technical/Layout";

import ComponentLoader          from "../../Components/Layout/Loaders/Loader";

/**
 * 
 * @returns Services page
 * 
 */

const SingleInfo = () => { const { t } = useTranslation (),

    { id } = useParams (),

    currentLanguage = cookies.get ( "i18next" ),

    { loading, data } = TechInfoModel (),

    selected = ! loading

        ? data.technicalInformation.edges.find ( obj => String ( obj.node.id ) === String ( id ) && ( ! currentLanguage || obj.node.language === currentLanguage ) )
            || data.technicalInformation.edges.find ( obj => String ( obj.node.id ) === String ( id ) )

        : null,

    node = selected ? selected.node : null,

    ContentComponent = node?.contentComponent || null;

    /** @return component */

    return ( <div className="container max-content-width">

        <Breadcrumbs collection={ [

            { name: t ( "technical_info" ), URI: `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_techinfo__" ) }` },

            { name: loading ? `${ t ( "loading" ) }...` : ( node ? node.title : t ( "technical_info" ) ), URI: `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_techinfo__" ) }` }

        ] } type="basic" />

        <Layout title={ t ( "technical_info" ) }>

            <div className="paragraph">

                { loading && <ComponentLoader /> }

                { ! loading && node && ContentComponent && <ContentComponent /> }

                { ! loading && node && ! ContentComponent && parse ( node.content ) }

                { ! loading && ! node && <p>Technical information page was not found.</p> }

            </div>

        </Layout>
        
    </div> );

}

/** @export SingleInfo */
 
export default SingleInfo;